// extracted by mini-css-extract-plugin
module.exports = {"iconLink":"styles_iconLink__16ga3","arrow":"styles_arrow__1A6Qc"};